var TxPowerTypes;
(function (TxPowerTypes) {
    TxPowerTypes["SX1261"] = "SX1261";
    TxPowerTypes["SX1262"] = "SX1262";
})(TxPowerTypes || (TxPowerTypes = {}));
export default TxPowerTypes;
